RivalIQ.apps.Reports.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    RivalIQ.apps.Dashboard.on('before:start', function () {
        const types = RivalIQ.state.timePeriods.types;

        data.dates = new Backbone.Collection([
            RivalIQ.state.timePeriods.get(types.LAST_SEVEN_DAYS),
            RivalIQ.state.timePeriods.get(types.LAST_THIRTY_DAYS),
            RivalIQ.state.timePeriods.get(types.LAST_NINETY_DAYS)
        ]);
    });
});
